import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";

const { carbon } = colorsPalettes;

export const StyledShareWrapper = styled(FlexColumn)`
    gap: 6px;
    height: 100%;
    justify-content: start;
`;

export const StyledShareTitle = styled.div`
    ${setFontVariant("listItem3", carbon[400])};
    text-wrap: nowrap;
`;

export const StyledShareData = styled(FlexRow)`
    gap: 4px;
`;

export const StyledSharePercent = styled(FlexRow)`
    ${setFontVariant("h6", carbon[500])};
    align-items: center;
    text-wrap: nowrap;
`;

export const StyledSharePercentPoint = styled.div`
    .customChangeIndication {
        padding: 4px 12px 4px 8px;
        ${setFontVariant("primaryItem")}
    }

    .change-indication__value {
        font-size: 14px;
    }
`;
